import { Moment } from 'moment';
import { Country } from './country';
import { LanguageCourse } from './language-course';
import { ProgrammeType } from './programme-type';
import { SalesAgent } from './sales-agent';
import { School } from './school';
import { SystemUser } from './system-user';
import { StudentContactType } from './student-contact-type';

export class BookingRequestToApprove {

    constructor(
        public firstName: string,
        public familyName: string,
        public age: number,
        public nationality: string,
        public firstLanguage: string,
        public phoneNumber: string,
        public email: string,
        public city: string,
        public country: string,
        public otherCountry: string,
        public programme: string,
        public lessonsPerWeek: string,
        public programmeOption: string,
        public startDay: Moment,
        public endDay: Moment,
        public otherNationality: string,
        public accommodationType: string,
        public roomType: string,
        public board: string,
        public nonSmokingFamily: string,
        public familyWithNoKids: string,
        public familyWithNoPets: string,
        public allergyOrMedicalIssues: string,
        public accommodationPreference: string,
        public mobileNumber: string,
        public gender: string,
        public birthPlace: string,
        public birthDate: Moment,
        public targetLanguageLevel: string,
        public learningDifficulty: string,
        public street: string,
        public additionalAddress: string,
        public emergencyContactName: string,
        public emergencyContactType: StudentContactType,
        public emergencyContactEmail: string,
        public emergencyContactPhone: string,
        public parentName: string,
        public parentProfession: string,
        public parentEmail: string,
        public parentPhone: string,
        public travelWithLvi: string,
        public airportTransferType: string,
        public needCancellationGuarantee: string,
        public needMedicalInsurance: string,
        public promotionCode: string,
        public informationSource: string,
        public comment: string,
        public created: Moment,
        public isApproved: boolean,
        public language: string,
        public hobbies: string,
        public billingCurrency: string,
        public billingContact: string,
        public paymentMethod: string,
        public billingPersonName: string,
        public billingPersonPhone: string,
        public billingPersonEmail: string,
        public billingPersonStreet: string,
        public billingPersonExtraAddress: string,
        public billingPersonCity: string,
        public billingPersonCountry: string,
        public billingPersonPostalCode: string,
        public billingPersonOtherCountry: string,
        public postalCode: string,
        public school: string,
        public languageTeacher: string,
        public schoolAddress: string, 
        public siblingsAge: string,
        public lastModified: Moment,
        public lastModifiedBy: SystemUser,
        public isDeleted: boolean,
        public languageCourse: LanguageCourse,
        public destination?: Country | null,
        public programmeType?: ProgrammeType | null,
        public id?: number,
        public agent?: SalesAgent,
        public lviSchool?: School,
        public contactRequestId?: number,
        public duration?: number
    ){}
}
